import { render, staticRenderFns } from "./factoryManage.vue?vue&type=template&id=2438661e"
import script from "./factoryManage.vue?vue&type=script&lang=js"
export * from "./factoryManage.vue?vue&type=script&lang=js"
import style0 from "./factoryManage.vue?vue&type=style&index=0&id=2438661e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports